import styled from "styled-components";
import { StyledText } from "../../../../components/common";
import { ChevronRightArrow } from "../../../../components/svgs";

export const SummaryPage = ({
  state,
  background,
  gotoEditPage,
  modeOfAttendance,
}) => {
  // Function to render StyledText for contact details
  const renderContactDetail = (label, value) => (
    <StyledText
      size={12}
      style={{ fontFamily: "MTNRegular", marginBottom: "2px" }}
      margin="0"
    >
      {`${label}: ${value}`}
    </StyledText>
  );

  // Mapping of education levels to human-readable labels
  const educationLevelOptions = {
    highschool: "High School",
    undergraduate: "Undergraduate Degree",
    postgraduate: "Post Graduate Degree",
    other: "Other",
  };

  // Get the display value for education level
  const displayEducationLevel =
    educationLevelOptions[state?.educationLevel] || "Not specified";

  return (
    <>
      <div>
        <StyledText size={36} style={{ fontFamily: "MTNMedium" }} margin="0">
          {"Digital Skills Training program"}
        </StyledText>
        <StyledText
          size={12}
          style={{ fontFamily: "MTNRegular", margin: "10px 0" }}
          margin="0"
        >
          {modeOfAttendance == "online"
            ? "Online Session"
            : "MTN House, Independence Avenue, Accra"}
        </StyledText>
        <StyledText size={12} style={{ fontFamily: "MTNMedium" }} margin="0">
          June 27, 2025 - 8:00 AM
        </StyledText>
      </div>

      <HorizontalLine />

      <div
        onClick={gotoEditPage}
        style={{
          padding: "15px",
          border: `1px solid ${background}`,
          borderRadius: "10px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <StyledText
            size={18}
            style={{ fontFamily: "MTNMedium", marginBottom: "10px" }}
            margin="0"
          >
            Edit Contact Details
          </StyledText>
          {renderContactDetail("Name", state?.fullname)}
          {renderContactDetail("Phone", state?.phone)}
          {renderContactDetail("Email", state?.emailAddress)}
          {renderContactDetail("WhatsApp Number", state?.whatsappNumber)}
          {renderContactDetail("Educational Level", displayEducationLevel)}
          {renderContactDetail("Attendance Type", modeOfAttendance)}
        </div>
        <ChevronRightArrow width={16} height={16} fill={background} />
      </div>
    </>
  );
};

const HorizontalLine = styled.div`
  margin: 20px 0;
  border-top: none;
  border-bottom: 1px solid #ddd;
`;
